/**
 * Representative Details form validation utilities
 */

export interface RepresentativeFormErrors {
  repFirstName: string;
  repLastName: string;
  repTitle: string;
  repEmail: string;
  adminRole: string;
  [key: string]: string; // Allow index signature for compatibility with child components
}

export interface ValidationResult {
  isValid: boolean;
  errors: RepresentativeFormErrors;
}

export interface ShareholderDirector {
  firstName?: string;
  lastName?: string;
  email?: string;
}

export interface RepresentativeFormData {
  repFirstName: string;
  repLastName: string;
  repEmail: string;
  representative_title: string;
  adminRole: string;
  shareholdersDirectors: ShareholderDirector[];
  numOfShareholdersDirectors: number;
}

/**
 * Validate representative details form
 * Returns validation result with all error messages
 */
export const validateRepresentativeForm = (
  data: RepresentativeFormData
): ValidationResult => {
  const errors: RepresentativeFormErrors = {
    repFirstName: "",
    repLastName: "",
    repTitle: "",
    repEmail: "",
    adminRole: "",
  };

  let isValid = true;

  // Validate admin role
  if (!data.adminRole) {
    errors.adminRole = "Your role in the company is required";
    isValid = false;
  }

  // Validate directors
  for (let i = 0; i < data.numOfShareholdersDirectors; i++) {
    const director = data.shareholdersDirectors[i];

    if (!director?.firstName) {
      errors[`shareholdersDirectors.${i}.firstName`] =
        "Director's First Name is required";
      isValid = false;
    }

    if (!director?.lastName) {
      errors[`shareholdersDirectors.${i}.lastName`] =
        "Director's Last Name is required";
      isValid = false;
    }

    if (!director?.email) {
      errors[`shareholdersDirectors.${i}.email`] =
        "Director's Email is required";
      isValid = false;
    }
  }

  // Validate representative fields
  if (!data.repFirstName) {
    errors.repFirstName = "Representative's First Name is required";
    isValid = false;
  }

  if (!data.repLastName) {
    errors.repLastName = "Representative's Last Name is required";
    isValid = false;
  }

  if (!data.repEmail) {
    errors.repEmail = "Representative's Email is required";
    isValid = false;
  }

  if (!data.representative_title) {
    errors.repTitle = "Representative's Title is required";
    isValid = false;
  }

  return { isValid, errors };
};
